import {
  combineReducers
} from 'redux';
import {
  routerReducer
} from 'react-router-redux';
import authentication from './authentication';
import visibility from './visibility';

export default combineReducers({
  routing: routerReducer,
  authentication: authentication,
  visibility: visibility
});



// WEBPACK FOOTER //
// ./src/store/reducers/index.js